import React, {useState} from "react";
import * as formStyles from './../../../styles/forms.module.scss';

import { Button } from "../../buttons";

const AddressLookupForm = ({
    fields,
    formData,
    handleChange,
    invalidFields,
}) => {

    const [addressOptions, setAddressOptions] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [addressInput, setAddressInput] = useState("");
    const [showLookup, setShowLookup] = useState(true);

    const lookupAddress = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setAddressOptions([]);

        fetch("/api/getAddress", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ address: addressInput }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setLoading(false);
                setAddressOptions(data);
            })
            .catch((error) => {
                setLoading(false);
                setError(error.message);
            });

    };

    const handleAddressSelect = (address) => {
        setSelectedAddress(address);
        setShowLookup(false);
        
        //if we have a selected address, set address to true, otherwise false
        handleChange({
            name: "address",
            value: address?.premise?.length > 0,
            type: "address"
        });

        fields.forEach((field) => {
            if (field.map == 'premise') {
                handleChange({
                    name: field.name,
                    value: address.premise,
                    type: ""
                });
            } else if (field.map == 'street') {
                handleChange({
                    name: field.name,
                    value: address.street,
                    type: ""
                });
            }
            else if (field.map == 'postcode') {
                handleChange({
                    name: field.name,
                    value: address.postcode,
                    type: ""
                });
            }
        });
    }

    const handleRepick = (e) => {
        e.preventDefault();
        setSelectedAddress(null);
        setShowLookup(true);
        // Reset address validation status
        handleChange({
            name: "address",
            value: false,
            type: "address"
        });
    }

    return (
        <div className="address-lookup">
            {showLookup ? (
                <>
                    <label
                        style={{
                            border: invalidFields?.address ? "1px solid red" : "none"
                        }}>
                        Address Lookup
                        <div style={{
                            display: "flex",
                            gap: '.5rem'
                        }}>
                            <input
                                style={{margin: 0}}
                                type="text"
                                value={addressInput}
                                onChange={(e) => setAddressInput(e.target.value)}
                                placeholder="Enter address"
                            />
                            <Button 
                                colorData="white"
                                size={'small'}
                                elementType="button" 
                                content={loading ? "Loading..." : "Lookup"} 
                                disabled={loading}
                                clickEvent={lookupAddress}
                            />
                        </div>
                    </label>
                    {error && <p className="error">{error}</p>}
                    {addressOptions.length > 0 && (
                        <select
                            className="address-select"
                            onChange={(e) =>
                                handleAddressSelect(addressOptions[e.target.value])
                            }
                        >
                            <option value="">Select an address</option>
                            {addressOptions.map((option, index) => (
                                <option key={index} value={index}>
                                    {option.premise} {option.street}, {option.postcode}
                                </option>
                            ))}
                        </select>
                    )}
                </>
            ) : (
                <div className={formStyles.addressSummary}>
                    <h4>Selected Address</h4>
                    <p>
                        {selectedAddress?.premise} {selectedAddress?.street}, {selectedAddress?.postcode}
                    </p>
                    <Button 
                        size={'small'}
                        elementType="button"
                        content="Change Address"
                        className={formStyles.repickButton}
                        clickEvent={handleRepick}
                    />
                </div>
            )}
        </div>
    );
}

export default AddressLookupForm;